/**
 * Shared visitor search param validation.
 * Used by both $mapSlug.tsx and $orgSlug.$mapSlug.tsx routes.
 */
export type VisitorTab = "map" | "search" | "events" | "more";

export interface VisitorSearchParams {
  tab: VisitorTab;
  category: string | undefined;
  poi: string | undefined;
  view: "list" | "events" | "sponsors" | "faq" | "faqs" | undefined;
  ref: string | undefined;
  list: string | undefined;
  embed: "true" | undefined;
  /** Filter events tab to a single POI (deep-link from POI sheet "see all events") */
  poiFilter: string | undefined;
}

/** Empty search params — use when redirecting without forwarding search state */
export const EMPTY_VISITOR_SEARCH: VisitorSearchParams = {
  tab: "map",
  category: undefined,
  poi: undefined,
  view: undefined,
  ref: undefined,
  list: undefined,
  embed: undefined,
  poiFilter: undefined,
};

const VALID_TABS = new Set<string>(["map", "search", "events", "more"]);

export function validateVisitorSearch(search: Record<string, unknown>): VisitorSearchParams {
  // poiFilter only applies on the events tab — strip it elsewhere to prevent
  // phantom state when navigating across tabs.
  const tab = VALID_TABS.has(search.tab as string) ? (search.tab as VisitorTab) : "map";
  return {
    tab,
    category: (search.category as string) || undefined,
    poi: (search.poi as string) || undefined,
    view: search.view === "list" ? ("list" as const) : search.view === "events" ? ("events" as const) : search.view === "sponsors" ? ("sponsors" as const) : search.view === "faq" ? ("faq" as const) : search.view === "faqs" ? ("faqs" as const) : undefined,
    ref: (search.ref as string) || undefined,
    list: (search.list as string) || undefined,
    embed: search.embed === "true" ? ("true" as const) : undefined,
    poiFilter: tab === "events" ? ((search.poiFilter as string) || undefined) : undefined,
  };
}
